import React from "react";

export default React.createContext<{
  room: string;
  setRoom(room: string): void;
}>({ room: "", setRoom: () => {} });
